import { AppLocale } from '@core-types/app-locale';
import { CurrentUserDto } from '@domain/user/current-user.dto';

export class CurrentUser {
  id!: number;
  invitation_url!: string;
  last_sign_in_at!: string | Date | null;
  first_name!: string;
  last_name!: string;
  email!: string;
  status!: { status: string; localized: string };
  role!: {
    id: number;
    name: string;
  };
  created_at!: string | Date | null;
  locale!: AppLocale;
  company!: {
    id: number;
    name: string;
    localization: AppLocale;
    time_zone_name: string;
    time_zone: string;
    base_currency: string;
    next_exchange_time: string | Date | null;
    is_altitems_imported: boolean;
    is_concept_used: boolean;
    is_inventory_system_used: boolean;
    is_extended_dashboard_periods_used: boolean;
    first_day_of_week: 'monday' | 'sunday' | null;
    ai_features: boolean;
  };
  available_category_ids: number[] = [];

  static create(user: CurrentUserDto): CurrentUser {
    return new CurrentUser(user);
  }

  constructor(user: CurrentUserDto) {
    Object.assign(this, user);
  }

  get fullName() {
    return `${this.first_name} ${this.last_name}`;
  }
}
